import { useQuery } from 'react-query';

import { axios } from 'lib/axios';

const getCompanySettings = async (companyId) => {
  const {
    data: { data: settings },
  } = await axios.get(`/api/companies/${companyId}/settings`);
  return settings;
};

export const useCompanySettings = (companyId, queryOptions = {}) =>
  useQuery(['company-settings', companyId], () => getCompanySettings(companyId), {
    initialData: [],
    enabled: !!companyId,
    ...queryOptions,
  });
